export default "__VITE_ASSET__BJnVdxAe__"